import styled from 'styled-components';

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 410px;
  max-width: calc(100vw - 48px);
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.4);
  border-radius: 12px;
  padding: 28px 32px;
  background-color: ${({ theme }) => theme.colors.background.dark};
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CloseButton = styled.button`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: transparent;
  cursor: pointer;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 12px;
`;
